import Papa from "papaparse";
import type { ParseConfig, ParseResult } from "papaparse";

export function parseCsv<R>(
  csv: File | string,
  config: Partial<ParseConfig>,
): Promise<ParseResult<R>> {
  return new Promise((resolve, reject) => {
    Papa.parse(csv, {
      ...config,
      complete: (results: ParseResult<R>) => {
        resolve(results);
      },
      error: (error) => reject(error),
    });
  });
}
